import queryString from "query-string";
import { CURRENT_ACCOUNT_ID } from "../../api/helpers/bearerToken";
import { transformHelium10Domain } from "../../credentials/consts/links";
export const getUrlWithSearchParams = (baseUrl, queryParamsProps, options) => {
    const updateWithAccountId = options?.hasAccountId ?? true;
    delete options?.hasAccountId;
    const link = queryString.stringifyUrl({ url: baseUrl, query: queryParamsProps }, { skipEmptyString: true, skipNull: true, ...options });
    //TODO remove transformHelium10Domain after all tools added this
    return transformHelium10Domain(updateWithAccountId ? updateLinkWithAccountId(link) : link);
};
export const parseQueryString = (search) => {
    return Object.fromEntries(new URLSearchParams(search));
};
export const getAccountId = () => queryString.parse(window.location.search)["accountId"] ||
    sessionStorage.getItem(CURRENT_ACCOUNT_ID) ||
    window.accountId;
export const updateLinkWithAccountId = (url) => {
    const { url: baseUrl, query: originQuery } = queryString.parseUrl(url);
    const query = {
        ...originQuery,
        accountId: getAccountId(),
    };
    return queryString.stringifyUrl({ url: baseUrl, query });
};
